export const colors = {monitoring: "#0090FF", reports: "#E54D2E", tracking: "#46A758", maintenance: "#A18072"}
export const hslColor = {
    background: 'hsl(0 0% 100%)',
    foreground: 'hsl(229 84% 5%)',
    tab: 'hsl(210 40% 96.1%)',
    tabForeground: 'hsl(222.2 47.4% 11.2%)',
    popover: 'hsl(210 40% 96.1%)',
    popoverForeground: 'hsl(222.2 47.4% 11.2%)',
    primary: 'hsl(221.2 83.2% 53.3%)',
    primaryForeground: 'hsl(222.2 47.4% 11.2%)',
    secondary: 'hsl(210 40% 96.1%)',
    secondaryForeground: 'hsl(222.2 47.4% 11.2%)',
    muted: 'hsl(210 40% 96.1%)',
    mutedForeground: 'hsl(222.2 47.4% 11.2%)',
    accent: 'hsl(210 40% 96.1%)',
    accentForeground: 'hsl(222.2 47.4% 11.2%)',
    destructive: 'hsl(210 40% 96.1%)',
    destructiveForeground: 'hsl(222.2 47.4% 11.2%)',
    border: 'hsl(214.3 31.8% 91.4%)',
    borderForeground: 'hsl(217.2 32.6% 17.5%)',
    input: 'hsl(210 40% 96.1%)',
    inputForeground: 'hsl(222.2 47.4% 11.2%)',
    ring: 'hsl(210 40% 96.1%)',
    ringForeground: 'hsl(222.2 47.4% 11.2%)',
}
export const rgbColor = {
    background: 'rgb(255,255,255)',
    foreground: 'rgb(2,6,23)',
    border: 'rgb(226,232,240)',
    borderForeground: 'rgb(30,41,59)',

    primary: 'rgb(37,99,235)',

    worked: 'rgb(22, 163, 74)',
    stopped: 'rgb(251,191,36)',
    turned_off: 'rgba(128,128,128,0.1)',
    repair: 'rgba(250,127,80,1)',
    service: 'rgba(0,191,255,1)',
    broken: 'rgba(178,34,34,1)',
    maintenance: 'rgba(234,88,12,1)',
    other: 'rgba(234,88,12,1)',

    maintenanceWorked: 'rgb(0, 59, 54)',
    maintenanceStopped: 'rgb(234, 88, 12)',

    iteractionOn: 'rgb(37,99,235)',
    iteractionOff: 'rgba(128,128,128,0)',

    bigIdles: 'rgb(221,110,66)',
    smallIdles: 'rgb(232,218,178)',
    workProcessIdles: 'rgb(93,183,222)',
    maintenanceIdles: 'rgb(251,191,36)',
    lateStartIdles: 'rgb(226,109,92)',
    earlyFinishIdles: 'rgb(79,109,122)',
    emptyShiftsIdles: 'rgba(128,128,128,0.1)'
}

export const hexColor = {
    background: '#FFFFFF',
    foreground: '#020617',
    primary: '#2563EB',
    border: '#E2E8f0',
    borderForeground: '#1E293B',
    destructive: '#B0228C',

    worked: '#16A34A',
    stopped: '#FBBF24',
    turned_off: 'rgba(128,128,128,0.1)',
    repair: '#FF7F50',
    broken: '#B22222',
    service: '#00BFFF',
    maintenance: '#EA580C',
    other: '#808080',

    maintenanceWorked: '#003B36',
    maintenanceStopped: '#EA580C',

    bigIdles: '#dd6e42',
    smallIdles: '#e8dab2',
    workProcessIdles: '#5db7de',
    maintenanceIdles: '#FBBF24',
    lateStartIdles: '#E26D5C',
    earlyFinishIdles: '#4f6d7a',
    emptyShiftsIdles: 'rgba(128,128,128,0.1)'
}